<router-outlet />
<ocp-toast />
@if (isBlocked()) {
  <div class="app-block-overlay"></div>
}
